<template>
  <div class="element-input element-radio" :class="{ haveSubtext }">
    <div class="label">{{ label }}</div>
    <ul>
      <li :class="{ on: value == item.value }" v-for="item in items" @click="selectItem( item.value )">
        <template v-if="haveSubtext">
          <p class="primary-text">{{ item.label }}</p>
          <p class="secondary-text">{{ item.description }}</p>
        </template>
        <template v-else>
          {{ item.label }}
        </template>
      </li>
    </ul>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "haveSubtext" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    }
  }
}
</script>
